import React from "react";
import { PlaceHolderItem } from "../model";
import {
  Checkbox,
  DatePicker,
  Form,
  Input,
  Select,
  Tooltip,
  TreeSelect,
} from "antd";
import { placeholderOptions } from "../constant";
import { isEmpty } from "../../../Service/Utils";

const DatePick: any = DatePicker;
const RangePicker: any = DatePicker.RangePicker;

type Props = {
  placeholder: PlaceHolderItem;
  disabled?: boolean;
  rawDate: boolean;
  md: {
    [key: string]: any;
  };
};

const PlaceHolderInput: React.FC<Props> = ({
  placeholder,
  disabled,
  md,
  rawDate,
}) => {
  switch (placeholder.format) {
    case "BCZ_STAFF_UID":
      return (
        <Form.Item
          label={placeholder.name}
          name={["placeHolder", placeholder.name]}
          required={isEmpty(placeholder.column)}
        >
          <Select
            disabled={disabled}
            mode="multiple"
            allowClear
            showSearch
            style={{ width: "100%", minWidth: 160, fontSize: 12 }}
            placeholder="员工"
            size="small"
          >
            {md.staffs?.map((staff, index) => (
              <Select.Option value={staff.id} key={staff.id + "" + index}>
                {staff.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      );
    case "IDENTITY":
    case "DEVICE_KIND":
    case "SEX":
    case "YES_OR_NO":
    case "CITY_LEVEL":
    case "DEVICE_PRICE":
    case "AD_KIND":
      return (
        <Form.Item
          label={placeholder.name}
          name={["placeHolder", placeholder.name]}
          required={isEmpty(placeholder.column)}
        >
          <Checkbox.Group
            options={placeholderOptions[placeholder.format].map((item) => {
              return { label: item.title, value: item.value };
            })}
          />
        </Form.Item>
      );
    case "PROVINCE":
      return (
        <Form.Item
          label={placeholder.name}
          name={["placeHolder", placeholder.name]}
          required={isEmpty(placeholder.column)}
        >
          <Select
            disabled={disabled}
            mode="multiple"
            allowClear
            showSearch
            style={{ width: "100%", minWidth: 160, fontSize: 12 }}
            placeholder="选择省份"
            size="small"
          >
            {md.provinces?.map((province) => (
              <Select.Option key={province.title} value={province.title}>
                {province.title}
              </Select.Option>
            ))}
            <Select.Option value="NULL">NULL</Select.Option>
          </Select>
        </Form.Item>
      );
    case "BCZ_WORD_BOOK": // bookCategories
      return (
        <Form.Item
          label={placeholder.name}
          name={["placeHolder", placeholder.name]}
          required={isEmpty(placeholder.column)}
        >
          <TreeSelect
            disabled={disabled}
            showSearch
            style={{ width: "100%", minWidth: 160, fontSize: 12 }}
            size="small"
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            placeholder="选择词书"
            allowClear
            multiple
            treeDefaultExpandAll
          >
            {md.bookCategories?.map((category, index) => (
              <TreeSelect.TreeNode
                value={category.key}
                title={category.title}
                key={category.key + index}
              >
                {category.children.map((book) => (
                  <TreeSelect.TreeNode
                    key={book.key}
                    value={book.title}
                    title={book.title}
                  />
                ))}
              </TreeSelect.TreeNode>
            ))}
          </TreeSelect>
        </Form.Item>
      );
    case "CITY":
      return (
        <Form.Item
          label={placeholder.name}
          name={["placeHolder", placeholder.name]}
          required={isEmpty(placeholder.column)}
        >
          <TreeSelect
            disabled={disabled}
            showSearch
            style={{ width: "100%", minWidth: 160, fontSize: 12 }}
            size="small"
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            placeholder="选择城市"
            allowClear
            multiple
            treeDefaultExpandAll
          >
            {md.provinces?.map((province, index) => (
              <TreeSelect.TreeNode
                value={province.key}
                title={province.title}
                key={province.key}
              >
                {province.children.map((city) => (
                  <TreeSelect.TreeNode
                    value={city.title}
                    title={city.title}
                    key={city.title}
                  />
                ))}
              </TreeSelect.TreeNode>
            ))}
          </TreeSelect>
        </Form.Item>
      );
    case "AD_POSITION":
      return (
        <Form.Item
          label={placeholder.name}
          name={["placeHolder", placeholder.name]}
          required={isEmpty(placeholder.column)}
        >
          <TreeSelect
            disabled={disabled}
            showSearch
            style={{ width: "100%", minWidth: 160, fontSize: 12 }}
            size="small"
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            placeholder="请选择广告位"
            allowClear
            multiple
            treeDefaultExpandAll
          >
            {md.adSlots?.map((app) => (
              <TreeSelect.TreeNode
                value={app.key}
                title={app.title}
                key={app.key}
              >
                {app.children.map((slot) => (
                  <TreeSelect.TreeNode
                    value={slot.title}
                    title={slot.title}
                    key={slot.title}
                  />
                ))}
              </TreeSelect.TreeNode>
            ))}
          </TreeSelect>
        </Form.Item>
      );
    case "TO_GROUP":
    case "FROM_GROUP":
      return (
        <Form.Item
          label={placeholder.name}
          name={["placeHolder", placeholder.name]}
          required={isEmpty(placeholder.column)}
        >
          <Checkbox.Group
            disabled={disabled}
            options={md.toGroupsToObjects?.map((toGroup) => {
              return { value: toGroup.key, label: toGroup.title };
            })}
          />
        </Form.Item>
      );
    case "TO_OBJECT":
      return (
        <Form.Item
          label={placeholder.name}
          name={["placeHolder", placeholder.name]}
          required={isEmpty(placeholder.column)}
        >
          <TreeSelect
            disabled={disabled}
            showSearch
            style={{ width: "100%", minWidth: 160, fontSize: 12 }}
            size="small"
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            placeholder="请选择承接对象"
            allowClear
            multiple
            treeDefaultExpandAll
          >
            {md.toGroupsToObjects?.map((toGroup) => (
              <TreeSelect.TreeNode
                value={toGroup.key}
                title={toGroup.title}
                key={toGroup.key}
              >
                {toGroup.children.map((toObject) => (
                  <TreeSelect.TreeNode
                    value={toObject.key}
                    title={toObject.title}
                    key={toObject.key}
                  />
                ))}
              </TreeSelect.TreeNode>
            ))}
          </TreeSelect>
        </Form.Item>
      );
    case "USER_GRADE":
      return (
        <Form.Item
          label={placeholder.name}
          name={["placeHolder", placeholder.name]}
          required={isEmpty(placeholder.column)}
        >
          <Select
            disabled={disabled}
            showSearch
            mode="multiple"
            allowClear
            size="small"
            placeholder="请选择年级"
            style={{ width: "100%" }}
          >
            {placeholderOptions.USER_GRADE.map((opt) => (
              <Select.Option value={opt.value} key={opt.value}>
                {opt.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      );
    case "MULTI_INPUT":
    case "LIKE_INPUT":
    case "INPUT":
      return (
        <Form.Item
          label={placeholder.name}
          name={["placeHolder", placeholder.name]}
          required={isEmpty(placeholder.column)}
        >
          <Input
            disabled={disabled}
            allowClear
            size="small"
            style={{ width: "100%", fontSize: 12, minWidth: 90, maxWidth: 328 }}
          />
        </Form.Item>
      );
    case "DATE_RANGE":
      return (
        <Form.Item
          label={placeholder.name}
          name={["placeHolder", placeholder.name]}
          required={isEmpty(placeholder.column)}
        >
          <RangePicker size="small" style={{ width: "100%", fontSize: 12 }} />
        </Form.Item>
      );
    default:
      if (placeholder.format.startsWith("OPTS:")) {
        const keys = placeholder.format.substring(5).split(",");
        return (
          <Form.Item
            label={placeholder.name}
            name={["placeHolder", placeholder.name]}
            required={isEmpty(placeholder.column)}
          >
            <Checkbox.Group
              options={keys.map((opt) => {
                return { value: opt, label: opt };
              })}
            />
          </Form.Item>
        );
      } else {
        if (rawDate) {
          return (
            <Tooltip title="可以输入相对日期(${dt-1}/${dt-2}/${dt-X})">
              <Form.Item
                label={placeholder.name}
                name={["placeHolder", placeholder.name]}
                rules={[
                  {
                    required: isEmpty(placeholder.column),
                    message: placeholder.name + "不可为空",
                  },
                  { pattern: /^\$\{dt[-+][0-9]+\}$/, message: "格式错误" },
                ]}
                required={isEmpty(placeholder.column)}
              >
                <Input
                  disabled={disabled}
                  allowClear
                  size="small"
                  style={{ width: "200px", fontSize: 12 }}
                ></Input>
              </Form.Item>
            </Tooltip>
          );
        } else {
          return (
            <Form.Item
              label={placeholder.name}
              name={["placeHolder", placeholder.name]}
              required={isEmpty(placeholder.column)}
            >
              <DatePick
                disabled={disabled}
                size="small"
                style={{ width: "100%" }}
              />
            </Form.Item>
          );
        }
      }
  }
};

export default PlaceHolderInput;
